var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FA9C4624-8679-415E-AE49-A9F41202C16C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.31969016,1.89711902 C9.50455165,-0.178039729 12.4954485,-0.178039729 13.6803099,1.89711902 L13.6803099,1.89711902 L21.3392339,15.3009858 C22.5148246,17.35893 21.0288763,19.92 18.6590001,19.92 L18.6590001,19.92 L3.34100002,19.92 C0.970063323,19.92 -0.516016155,17.3587039 0.660808684,15.3009115 L0.660808684,15.3009115 Z M12.3776902,2.64088091 C11.7685517,1.57403964 10.2314484,1.57403964 9.62219137,2.64108847 L9.62219137,2.64108847 L1.96305375,16.0453292 C1.35800649,17.1033131 2.1219562,18.42 3.34100002,18.42 L3.34100002,18.42 L18.6590001,18.42 C19.8771044,18.42 20.6411853,17.103087 20.0368088,16.0450885 L20.0368088,16.0450885 Z M10.999,13.505 L11.1156933,13.51172 C11.6133664,13.5694203 11.999993,13.9916563 11.999993,14.505 C11.999993,15.0572156 11.5522116,15.505 10.999993,15.505 C10.4477844,15.505 9.99999295,15.0572115 10.0000197,14.5104347 C9.9962666,13.9925013 10.3873731,13.5655316 10.8897485,13.5109042 L10.999,13.505 Z M11,6.75999998 C11.3796958,6.75999998 11.693491,7.04215387 11.7431534,7.40822943 L11.75,7.50999998 L11.75,11.25 C11.75,11.6642136 11.4142136,12 11,12 C10.6203043,12 10.3065091,11.7178461 10.2568467,11.3517706 L10.25,11.25 L10.25,7.50999998 C10.25,7.09578642 10.5857865,6.75999998 11,6.75999998 Z",
    id: "error-circle-path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "error-circle-PB-PARENT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "error-circle-08-ui-P-error-msg-v1",
    transform: "translate(-153.000000, -262.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "error-circle-error-circle",
    transform: "translate(153.000000, 262.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "error-circle-Oval",
    stroke: "#DE350B",
    fillOpacity: 0.06,
    fill: "#DE350B",
    cx: 35,
    cy: 35,
    r: 34.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "error-circle-postIcons/outlines/ic_error",
    transform: "translate(23.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "error-circle-Path",
    points: "0 0 24.0000001 0 24.0000001 24.0000001 0 24.0000001"
  }), /*#__PURE__*/React.createElement("g", {
    id: "error-circle-colours/neutral/N100",
    transform: "translate(1.000000, 1.870000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "error-circle-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#error-circle-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "error-circle-Mask",
    fill: "#323232",
    fillRule: "nonzero",
    xlinkHref: "#error-circle-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#error-circle-mask-2)",
    id: "error-circle-colours/error/RE400"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-49.000000, -50.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "error-circle-colours/secondary/R400",
    fill: "#DE350B",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircle);
export default __webpack_public_path__ + "static/media/error_circle.40f61afa9121517a7c1b0f16c5a6adb4.svg";
export { ForwardRef as ReactComponent };